import React from 'react';
import './RegistrationErrorDisplay.css';

const RegistrationErrorDisplay = ({ error, fieldErrors }) => {
  const activeFieldErrors = fieldErrors
    ? Object.fromEntries(
        Object.entries(fieldErrors).filter(([, message]) => Boolean(message))
      )
    : {};

  // Don't render if there are no errors
  if (!error && Object.keys(activeFieldErrors).length === 0) {
    return null;
  }

  return (
    <div className="registration-error-display">
      {error && (
        <div className="general-error">
          <div className="error-icon">⚠️</div>
          <div className="error-content">
            <h4>Registration Error</h4>
            <p>{error}</p>
          </div>
        </div>
      )}
      
      {Object.keys(activeFieldErrors).length > 0 && (
        <div className="field-errors">
          <h4>Please fix the following issues:</h4>
          <ul>
            {Object.entries(activeFieldErrors).map(([field, message]) => (
              <li key={field} className={`field-error field-error-${field}`}>
                <span className="field-name">{getFieldDisplayName(field)}:</span>
                <span className="field-message">{message}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

const getFieldDisplayName = (field) => {
  const fieldNames = {
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    password: 'Password',
    username: 'Username',
    name: 'Name',
    general: 'General'
  };
  return fieldNames[field] || field;
};

export default RegistrationErrorDisplay;
